import { render, staticRenderFns } from "./CameraBase.vue?vue&type=template&id=2107e4a9&scoped=true&"
import script from "./CameraBase.vue?vue&type=script&lang=ts&"
export * from "./CameraBase.vue?vue&type=script&lang=ts&"
import style0 from "./CameraBase.vue?vue&type=style&index=0&id=2107e4a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2107e4a9",
  null
  
)

export default component.exports